import { ref, reactive, onBeforeMount, watch, computed } from "vue";
import { apiWeeklyArticleSearch, apiWeeklyExport } from "@/request/api";
import { useRoute, useRouter } from "vue-router";
import withLoading from "@/utils/loading";
import { ElMessage } from "element-plus";
import { baseURL } from "@/request/http";
import { saveAsFile } from "@/utils/download";

export default () => {
    const route = useRoute();
    const router = useRouter();
    const query = reactive({
        keywords: route.query.keywords || "",
        tagId: route.query.tagId1 || "", // 板块id
        keyList: [], // 板块关键词
        releaseArr: [], // 来源
        countryArr: [], // 国家
        risk: [], // 风险等级
        startTime: "",
        endTime: "",
        pullStartTime: route.query.pullStartTime || "",
        pullEndTime: route.query.pullEndTime || "",
        sort: 1,
        pageNum: 1,
        pageSize: 15,
    });
    const total = ref(0);
    const listData = ref([]);
    const checkedList = ref([]); // 已选中文章id集合
    const isAll = ref(false); // 是否全选
    // 是否半选
    const allIndeterminate = computed(() => {
        return listData.value.some((item) => checkedList.value.includes(item.articleId)) && !listData.value.every((item) => checkedList.value.includes(item.articleId));
    });

    // 切换排序
    function changeSort(e) {
        if (query.sort === e) return;
        query.sort = e;
        getList();
    }

    // 获取列表
    async function getList() {
        const params = { ...query };
        if (params.pullStartTime?.length === 10) {
            params.pullStartTime += " 00:00:00";
        }
        if (params.pullEndTime?.length === 10) {
            params.pullEndTime += " 23:59:59";
        }
        const { data } = await withLoading(apiWeeklyArticleSearch)(params);
        total.value = data?.total || "";
        listData.value = data?.list || [];
        setChecked(); //设置和回显选中状态
        // 设置全选默认状态
        setAllChecked();
    }

    // 设置和回显选中状态
    function setChecked() {
        // 设置文章选中状态
        listData.value = listData.value.map((item) => {
            item.checked = false; // 默认值
            // 已选中时
            if (checkedList.value.includes(item.articleId)) {
                item.checked = true;
            }
            return item;
        });
    }

    // 分页
    watch(() => query.pageNum, getList);

    // 分页大小change
    function handleSizeChange() {
        query.pageNum = 1;
        getList();
    }

    // 搜索
    function search() {
        checkedList.value = [];
        if (query.keywords) {
            query.sort = 1;
        } else {
            query.sort = 2;
        }
        const newQuery = { ...route.query, keywords: query.keywords, tagId1: query.tagId, risk: query.risk.join(",") };
        delete newQuery.pullStartTime;
        delete newQuery.pullEndTime;
        router.replace({ query: newQuery });
        query.pageNum = 1;
        getList();
    }

    // 单个切换
    function checkedChange(e, item) {
        item.checked = e;
        if (e) {
            checkedList.value.push(item.articleId);
        } else {
            checkedList.value = checkedList.value.filter((id) => id !== item.articleId);
        }
        setAllChecked(); // 设置全选默认状态
    }

    // 板块标签改变
    function handleTagChange() {
        query.keyList = [];
        search();
    }

    // 全选切换
    function allChange(e) {
        isAll.value = e;
        let ids = listData.value.map((item) => item.articleId);
        if (e) {
            checkedList.value = [...new Set([...checkedList.value, ...ids])];
        } else {
            checkedList.value = checkedList.value.filter((id) => !ids.includes(id));
        }
        setChecked(); //设置和回显选中状态
    }

    // 设置全选默认状态
    function setAllChecked() {
        if (listData.value?.length) {
            isAll.value = listData.value.every((item) => checkedList.value.includes(item.articleId));
        } else {
            isAll.value = false;
        }
    }

    // 重置
    function handleReset() {
        query.tagId = "";
        query.keyList = [];
        query.releaseArr = [];
        query.countryArr = [];
        query.risk = [];
        query.startTime = "";
        query.endTime = "";
        query.pullStartTime = "";
        query.pullEndTime = "";
        query.pageNum = 1;
        search();
    }

    // 导出
    function exportExcel() {
        if (!total.value) {
            ElMessage.error("暂无数据");
            return;
        }
        let herf = baseURL + apiWeeklyExport() + "?";
        for (const key in query) {
            let val = query[key];
            if (key === "pullStartTime" && val?.length === 10) {
                val += " 00:00:00";
            }
            if (key === "pullEndTime" && val?.length === 10) {
                val += " 23:59:59";
            }
            if (Array.isArray(val)) {
                herf += `${key}=${val.join(",")}&`;
            } else {
                herf += `${key}=${val}&`;
            }
        }
        herf += `token=${localStorage.getItem("token")}`;
        saveAsFile(herf);
    }

    onBeforeMount(() => {
        // 初始化风险等级
        if (route.query.risk) {
            query.risk = route.query.risk.split(",");
        }
        // 判断是否执行首次搜索
        if (route.query.noSearch) {
            const q = { ...route.query };
            delete q.noSearch;
            router.replace({ query: q });
        } else {
            search();
        }
    });

    return { handleSizeChange, allChange, query, total, listData, handleTagChange, changeSort, search, handleReset, exportExcel, checkedList, checkedChange, getList, isAll, allIndeterminate };
};
